module.exports = __webpack_public_path__ + "solanaproject/img/watermark.a28b638a.png";